import { render, staticRenderFns } from "./SupportConversationView.vue?vue&type=template&id=322f889c&scoped=true&lang=pug"
import script from "./SupportConversationView.vue?vue&type=script&lang=js"
export * from "./SupportConversationView.vue?vue&type=script&lang=js"
import style0 from "./SupportConversationView.vue?vue&type=style&index=0&id=322f889c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322f889c",
  null
  
)

export default component.exports